<style lang="scss">




@media screen and (min-width: 55rem) {
  .schoolcard6-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    height: 20rem;

    .schoolcard6 {
      width: 80%;
      max-width: 1080px;
      box-shadow: 0px 0px 5px #e2dfdfdc;
      border-radius: 1rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 100%;
      .schoolcard6-image-container {
        height: 100%;
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .schoolcard6-image-logo {
          width: 6rem;
          height: 6rem;
          background-image: url("/media/yintai/school-card-2.png");
          background-size: 100% 100%;
        }
        .schoolcard6-image-text {
          font-size: 16px;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #333333;
          margin-top: 1rem;
        }
      }
      .schoolcard6-text-container {
        height: 18rem;
        width: 60%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .schoolcard6-text-list {
          height: 60%;
          display: flex;
          flex-direction: column;

          .schoolcard6-text-list-item {
            margin-top: 0.4rem;
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #7f7f7f;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .schoolcard6-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;

    .schoolcard6 {
      width: 80%;
      max-width: 1080px;
      box-shadow: 0px 3px 5px #e2dfdfdc;
      border-radius: 1rem;
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      justify-content: center;
      .schoolcard6-image-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .schoolcard6-image-logo {
          margin-top: 2em;
          width: 4rem;
          height: 4rem;
          background-image: url("/media/yintai/school-card-2.png");
          background-size: 100% 100%;
        }
        .schoolcard6-image-text {
          font-size: 12px;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #333333;
          margin-top: 1rem;
          white-space: nowrap;
        }
      }
      .schoolcard6-text-container {
        width: 80%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-bottom: 2rem;
        .schoolcard6-text-list {
          width: 100%;
          display: flex;
          flex-direction: column;

          .schoolcard6-text-list-item {
            width: 100%;
            margin-top: 0.4rem;
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #7f7f7f;
          }
        }
      }
    }
  }
}
</style>

<script>
export default {
  name: "title",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
